/**
 * Sparkline — mini AreaChart Recharts pour les KPI cards.
 * Affiche la série ca_cents d'un tableau de buckets sous forme de courbe légère.
 *
 * Props :
 *   data      : tableau de buckets [{ ca_cents }] issu de useSalesByPeriod
 *   color     : couleur du trait + zone (défaut bleu primaire)
 *   width     : largeur SVG (défaut 80)
 *   height    : hauteur SVG (défaut 28)
 */

import { AreaChart, Area, ResponsiveContainer } from 'recharts';

export default function Sparkline({
  data = [],
  color = '#3b82f6',
  width = 80,
  height = 28,
}) {
  if (!Array.isArray(data) || data.length < 2) return null;

  const chartData = data.map((b) => ({ v: (b.ca_cents ?? 0) / 100 }));

  return (
    <div style={{ width, height }} aria-hidden>
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart data={chartData} margin={{ top: 2, right: 0, bottom: 0, left: 0 }}>
          <defs>
            <linearGradient id={`sparkGrad-${color.replace('#', '')}`} x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor={color} stopOpacity={0.3} />
              <stop offset="95%" stopColor={color} stopOpacity={0} />
            </linearGradient>
          </defs>
          <Area
            type="monotone"
            dataKey="v"
            stroke={color}
            strokeWidth={1.5}
            fill={`url(#sparkGrad-${color.replace('#', '')})`}
            dot={false}
            isAnimationActive={false}
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
}
